export default "__VITE_ASSET__0897c499__"